<script>
import NSPlayer from "@/components/ns-player/NSPlayer.vue";
import VideoBlock from "@/components/VideoBlock.vue";

export default {
  components: { NSPlayer, VideoBlock },
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    fields: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  computed: {
    sortedFields() {
      const fields = this.fields;
      return fields.sort((a, b) => a?.order - b?.order);
    },
    editValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
    isDisabled() {
      const missingFields = this.fields.filter(
        (field) => field?.required && !this.editValue[field.key]
      );
      return missingFields.length !== 0;
    },
  },
  methods: {
    // Колонки для каждого элемента
    getCols(cols) {
      return cols ? cols : 6;
    },
    // async getImage(url) {
    //   try {
    //   } catch (error) {
    //   }
    // },
  },
};
</script>

<template>
  <v-container
    fluid
    fill-height
    class="align-start py-0 px-0"
    style="background-color: white"
  >
    <v-card width="100%" style="box-shadow: none">
      <v-card-text>
        <v-row>
          <v-col
            v-for="field in sortedFields"
            :key="field.key"
            :cols="getCols(field.cols)"
          >
            <div class="field-wrapper">
              <label :for="field.key">
                {{ field.label }}
              </label>
              <component
                class="text-field"
                v-if="field.component"
                :is="field.component"
                v-bind="field.componentAttributes"
                v-model="editValue[field.key]"
              />
              <div v-else-if="field.type === 'video'">
                <video-block :url="editValue[field.key]" />
              </div>
              <n-s-player
                v-else-if="field.type === 'nsPlayer'"
                ref="nsPlayer"
                :video_data="editValue[field.key]"
              />
              <div v-else-if="field.type === 'iframe'">
                <iframe
                  style="border: none"
                  width="100%"
                  height="450px"
                  allow="autoplay; fullscreen; encrypted-media; gyroscope; accelerometer; clipboard-write; screen-wake-lock;"
                  :src="`https://kinescope.io/embed/${
                    editValue[field.key]
                  }?autofocus=true`"
                ></iframe>
              </div>
              <v-img
                v-else-if="field.type === 'img'"
                width="auto"
                cover
                :src="editValue[field.key]"
              />
              <v-textarea
                class="text-field"
                v-else-if="field.type === 'text'"
                v-model="editValue[field.key]"
                flat
                solo
                outline
                hide-details
              />
              <v-radio-group
                v-else-if="field.type === 'radio'"
                v-model="editValue[field.key]"
              >
                <v-radio
                  v-for="(item, index) in field.variants"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </v-radio-group>
              <v-text-field
                v-else
                class="text-field"
                v-model="editValue[field.key]"
                :required="field.required"
                :type="field.typeInput"
                flat
                solo
                outline
                hide-details
              />
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          style="
            background-color: #d86568;
            width: 150px;
            height: 50px;
            border-radius: 50px;
          "
          class="white--text btn-save"
          :disabled="isDisabled"
          @click="$emit('submit', editValue)"
        >
          Сохранить
        </v-btn>
        <slot />
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<style scoped lang="scss">
$color-red: #d86568;

.text-field {
  border: 1px solid #23919e;
}

.text-field.invalid {
  border: 1px solid $color-red;
}

.text-field-hint {
  height: 20px;
  color: $color-red;
}

.btn-save {
  background-color: $color-red;
  width: 150px;
  height: 50px;
  border-radius: 50px;
}
</style>
